import { get } from "@/features/schemas/services/schemaApi";

function getDefaultState() {
    return {
        timeZone: "",
        cultureCode: null,
        isLoaded: false
    }
}

const state = getDefaultState;

const actions = {
    async load({ commit, rootState, dispatch }) {
        // Wait for schema module to complete loading
        await dispatch('schema/loadCompletion', null, { root: true });

        let user = rootState.authentication.user;
        const culture = await get('culture', null, user.cultureId);
        const timeZone = await get('timeZone', null, user.timeZoneId);
        commit("set", { culture, timeZone });
    },
    clear({ commit }) {
        commit("clear");
    }
};

const mutations = {
    set(state, { culture, timeZone }) {
        state.cultureCode = culture.code;
        state.timeZone = timeZone.name;
        state.isLoaded = true;
    },
    clear(state) {
        Object.assign(state, getDefaultState());
    }
};

export const localisation = {
    namespaced: true,
    state,
    actions,
    mutations
};
